/** 승인 예정일의 연·월을 `YY.MM` 형식으로 변환한다. */
const formatScheduledMoveInYm = (approvedDate) => {
  if (approvedDate === null || approvedDate === undefined) return null;

  // API별 yyyy-MM-dd, yyyy.MM.dd, yyyyMMdd 표현을 시간대 변환 없이 우선 해석한다.
  const value = String(approvedDate).trim();
  const matched = value.match(/^(\d{4})[-.]?(\d{2})[-.]?(\d{2})/);
  if (matched) {
    const month = Number(matched[2]);
    if (month >= 1 && month <= 12) return `${matched[1].slice(2)}.${matched[2]}`;
  }

  // 숫자 timestamp 응답도 지원하되 임의 문자열은 입주예정 fallback으로 남긴다.
  const timestamp = typeof approvedDate === "number" ? approvedDate : null;
  if (timestamp === null) return null;
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return null;
  const year = String(date.getFullYear()).slice(2);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}.${month}`;
};

/**
 * 서버가 내려준 아파트 연식을 사용자 표시 문자열로 변환한다.
 * 음수 연식은 승인 예정일이 있으면 연월을 표시하고, 없으면 입주예정으로 표시한다.
 */
export const formatAptAge = (
  age,
  suffix = "년차",
  emptyValue = null,
  approvedDate = null,
) => {
  if (age === null || age === undefined) return emptyValue;
  if (Number(age) >= 0) return `${age}${suffix}`;
  const scheduledYm = formatScheduledMoveInYm(approvedDate);
  return scheduledYm ? `${scheduledYm} 입주` : "입주예정";
};

/** 승인일만 있는 응답에서도 서버와 동일하게 방향이 보존된 연식을 계산한다. */
export const calculateAptAge = (approvedDate, now = new Date()) => {
  if (!approvedDate) return null;
  const approved = new Date(approvedDate);
  if (Number.isNaN(approved.getTime()) || Number.isNaN(now.getTime())) return null;

  const diffDays = Math.floor(Math.abs(approved.getTime() - now.getTime()) / 86400000);
  const years = Math.floor(diffDays / 365);
  // 1년 미만의 미래 승인일도 0이 아닌 음수여야 입주예정 상태를 잃지 않는다.
  return approved > now ? -Math.max(1, years) : years;
};
